import { Lock } from 'lucide-react';

/**
 * Silver "Members" chip shown on a VOD a free member can no longer play this
 * month. §3: silver, never red — gated content is an invitation, not an error.
 */
export function MembersLockChip() {
  return (
    <span className="inline-flex items-center gap-1 rounded-sm bg-video-bg/70 px-1.5 py-0.5 font-sans text-[0.65rem] uppercase tracking-[0.12em] text-silver ring-1 ring-silver/30">
      <Lock className="h-3 w-3" />
      Members
    </span>
  );
}
